const initState = {
  showDashboard: false,
  showTabBar: false, //是否隐藏工具条
  title: "客户列表",
}
const GLOBAL = (
  state = initState,
  action: {
    //
    type: any
    id: any
    text: any
    title: string
    showTabBar: boolean
    showDashboard: boolean
  },
) => {
  switch (action.type) {
    case "ADD_TODO":
      return { ...state, action }
    case "SET_TABBAR":
      return { ...state, showTabBar: action.showTabBar }
    case "SET_SHOWDASHBOARD":
      return { ...state, showDashboard: action.showDashboard }
    case "SET_TITLE":
      return { ...state, title: action.title }
    default:
      return state
  }
}

export default GLOBAL
